import React from 'react';
import { Link } from 'react-router-dom';
import { LinkContainer, StyledLink } from '#component/device/devices-popup/styles';

const AddRemoveLink = ({ propsProject }) =>
  <LinkContainer>
    {propsProject.length > 1 ? `${propsProject.length} root projects` :
    <Link
      component={StyledLink}
      to={{
        pathname: `project/edit/${propsProject.id ?? propsProject[0].id}`
      }}
    >
      Add/remove devices
    </Link>}
  </LinkContainer>;

export default AddRemoveLink;
